export enum Environment {
  Local = 'Local',
  Staging = 'Staging',
  Prod = 'Prod',
}

export const getEnvironmentFromHostname = (hostname: string): Environment => {
  if (hostname.includes('staging.ardennes-etape.com')) {
    return Environment.Staging;
  }
  if (
    hostname.includes('localhost') ||
    hostname.includes('loc.ardennes-etape.com')
  ) {
    return Environment.Local;
  }
  return Environment.Prod;
};
